'use strict';

import React from 'react';
import Navigator from './NavigatorComponent';
import Item from './ItemComponent';
import UserStore from 'stores/UserStore';
import UserActions from 'actions/UserActions';
import Loading from './LoadingComponent';

require('styles/Links.scss');

class LinksComponent extends React.Component {
  constructor(props) {
    super(props);
    let userStore = UserStore.getState();
    this.state = {
      links: userStore.links,
      loading: userStore.linksLoading,
      hasMore: userStore.linksHasMore,
      showNavigator: false
    }
    this.onChange = this.onChange.bind(this);
    this.onLinkScroll = this.onLinkScroll.bind(this);
    this.loadMore = this.loadMore.bind(this)
  }
  componentDidMount() {
    UserStore.listen(this.onChange);
    UserActions.clearData('links');
    UserActions.fetchLinks();
    window.addEventListener('scroll', this.onLinkScroll);
  }
  componentWillUnmount() {
    UserStore.unlisten(this.onChange);
    window.removeEventListener('scroll', this.onLinkScroll);
  }
  onChange(state) {
    this.setState({
      links: state.links,
      loading: state.linksLoading,
      hasMore: state.linksHasMore
    });
  }
  onLinkScroll(event) {
    if(this.state.fetchTimeout) {
      clearTimeout(this.state.fetchTimeout);
    }
    let scrollTop = $(document).scrollTop();
    let clientHeight = event.srcElement.body.clientHeight;
    let scrollHeight = event.srcElement.body.scrollHeight;
    if(scrollTop + clientHeight === scrollHeight) {
      UserActions.setLoading({linksLoading: true});
      this.setState({fetchTimeout: setTimeout(UserActions.fetchLinks.bind(null), 1000)});
    }
    if(scrollTop > 500){
      this.setState({showNavigator:true});
    }else {
      this.setState({showNavigator:false});
    }
  }
  loadMore() {
    UserActions.setLoading({linksLoading: true});
    UserActions.fetchLinks()
  }
  render() {
    let noMoreWord,navigator;
    if(this.state.links.length === 0) {
      noMoreWord = ' ';
    }
    if(this.state.showNavigator){
      navigator = <Navigator action = 'top' number={2} />;
    }
    return (
      <div className="links-component tabs-panel is-active">
        {this.state.links.map(link => {
          return (
            <Item 
              key={link._id} 
              type={4} 
              name={link.name?link.name:`${link.last_name} ${link.first_name}`} 
              wechat={link.wechat} 
              tel={link.tel} 
              email={link.email}/>
          )
        })}
        <Loading 
          noMoreWord={noMoreWord} 
          loadMore={this.loadMore}
          loading={this.state.loading} 
          hasMore={this.state.hasMore} />
        {navigator}
        <Navigator action='left' />
      </div>
    );
  }
}

LinksComponent.displayName = 'LinksComponent';
export default LinksComponent;



// WEBPACK FOOTER //
// ./src/components/LinksComponent.js